import { RouteHandles as SharedRouteHandles, Routes as SharedRoutes } from "@workleap-ai/shared";

export const Routes = {
    ...SharedRoutes
};

export const RouteHandles = {
    ...SharedRouteHandles
};
